"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=bed.dto.js.map